import axios from "axios";
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { Box, Divider, Typography } from "@material-ui/core";
import { Tooltip } from "@material-ui/core";
import { Close } from "@material-ui/icons";

let baseUrl = "data:image/png;base64,";

const ScenarioVersions = (props) => {
  console.log("prop", props);
  const [loading, setLoading] = useState(false);
  const [versionData, setVersionData] = useState([]);
  const columns = [
    {
      name: "Scenario Name",
      selector: "scenarioVariationName",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          {row.scenario_name.split(".zip")[0]}
        </div>
      ),
    },
    {
      name: "Scenario Description",
      selector: "scenarioVariationDiscription",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          {Object.keys(row.description).map((key) => {
            return (
              <div key={key}>
                <>{key}:</>
                <>{row.description[key]}</>
              </div>
            );
          })}
        </div>
      ),
      grow: 3,
    },
    {
      name: "Scenario Version",
      selector: "scenarioVersion",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>{row.scenario_version}</div>
      ),
    },
    {
      name: "Scenario Representation",
      selector: "scenarioVariationRepresentation",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>
          <img
            src={
              row.representation.startsWith("https://")
                ? row.representation
                : `${baseUrl}${row.representation.replace(/['"]+/g, "")}`
            }
            alt=""
            style={{ cursor: "pointer", padding: "10px" }}
            width="100"
            height="100"
          ></img>
        </div>
      ),
    },
    {
      name: "Scenario UUID",
      selector: "scenarioVariationUuid",
      sortable: true,
      reorder: true,
      cell: (row) => (
        <div style={{ flexWrap: "wrap" }}>{row.scenario_uuid}</div>
      ),
    },
    {
      name: "Updated On",
      selector: "updatedAt",
      sortable: true,
      reorder: true,
      cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.updated_at}</div>,
    },
    // {
    //   name: "Actions",
    //   selector: "actions",
    //   sortable: true,
    //   reorder: true,
    //   cell: (row) => (
    //     <div style={{ display: "flex", justifyContent: "space-around" }}>
    //       <Tooltip placement="top" title={<h6>Delete</h6>}>
    //       <IconButton aria-label="delete">{/* <AddIcon /> */}</IconButton>
    //       </Tooltip>
    //       <Tooltip placement="top" title={<h6>Delete</h6>}>
    //       <IconButton aria-label="delete">
    //         <DeleteIcon />
    //       </IconButton>
    //       </Tooltip>
    //       <Tooltip placement="top" title={<h6>Download</h6>}>
    //       <IconButton aria-label="delete">
    //         <CloudDownloadIcon />
    //       </IconButton>
    //       </Tooltip>
    //     </div>
    //   ),
    //   // cell: (row) => (
    //   //   <div style={{ flexWrap: "wrap" }}>
    //   //     <div
    //   //       style={{
    //   //         display: "inline-block",
    //   //         margin: "0.5rem",
    //   //         fontSize: "1.5rem",
    //   //       }}
    //   //     >
    //   //       {props.variationUuidList.includes(row.scenario_uuid) ? (
    //   //         <button
    //   //           style={
    //   //             Object.keys(props.scenarioObjectListData).length !== 0
    //   //               ? { backgroundColor: "#a8abf7" }
    //   //               : { backgroundColor: "#757AF7" }
    //   //           }
    //   //           // onClick={(e) => onDeselectScenarioVariation(e, row)}
    //   //           // disabled={
    //   //           //   Object.keys(props.scenarioObjectListData).length !== 0
    //   //           // }
    //   //         >
    //   //           <i className="fas fa-check-square"></i>
    //   //         </button>
    //   //       ) : (
    //   //         <button
    //   //           style={
    //   //             Object.keys(props.scenarioObjectListData).length !== 0
    //   //               ? { backgroundColor: "#a8abf7" }
    //   //               : { backgroundColor: "#757AF7" }
    //   //           }
    //   //           // onClick={(e) => onSelectScenarioVariation(e, row)}
    //   //           // disabled={
    //   //           //   Object.keys(props.scenarioObjectListData).length !== 0
    //   //           // }
    //   //         >
    //   //           <i className="fas fa-plus-square"></i>
    //   //         </button>
    //   //       )}
    //   //     </div>

    //   //     <button
    //   //       style={{
    //   //         backgroundColor: "red",
    //   //         fontSize: "1.5rem",
    //   //         margin: "0.5rem",
    //   //       }}
    //   //       // onClick={() => onDeleteVariation(row)}
    //   //     >
    //   //       <i className="fas fa-trash"></i>
    //   //     </button>
    //   //     <div
    //   //       style={{
    //   //         display: "inline-block",
    //   //         margin: "0.5rem",
    //   //         fontSize: "1.5rem",
    //   //       }}
    //   //     >
    //   //       <button
    //   //         style={{ cursor: "pointer" }}
    //   //         // onClick={(e) => downloadCmScenrio(e, row)}
    //   //       >
    //   //         <i className="fas fa-download"></i>
    //   //       </button>
    //   //     </div>
    //   //   </div>
    //   // ),
    // },
  ];
  const fetchScenarioVersions = async () => {
    setLoading(true);
    const response = await axios.post("/cm_close_loop/list_version_scenarios", {
      scenario_name: props.data.scenario_name,
      scenario_version: props.data.scenario_version,
      pages: 1,
    });
    setVersionData(response.data.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchScenarioVersions();
  }, []);
  console.log("PROPS IN VERSIONS", props);
  return (
    <>
      <Box style={{ display:"flex", justifyContent:"space-between", alignItems:"center"}}>
        <Typography variant="h5">
          Versions for {props.data.scenario_name}
        </Typography>
        <IconButton onClick={props.handleClose}>
          <Close />
        </IconButton>
      </Box>
      <Divider />

      <div
        style={{
          margin: "50px",
          border: "solid 1px rgba(0,0,0,.5)",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        {loading === false ? (
          <DataTable
            columns={columns}
            data={versionData}
            noDataComponent={"No Versions for the current scenario"}
            progressPending={loading}
            dense
          ></DataTable>
        ) : null}
      </div>
    </>
  );
};

export default ScenarioVersions;
